import React from "react";

const SkeletonText = ({
  size = "md",
  width = "full",
  className = "",
  lines = 1,
}) => {
  const sizeClasses = {
    xs: "h-2",
    sm: "h-3",
    md: "h-4",
    lg: "h-5",
    xl: "h-6",
  };

  const widthClasses = {
    full: "w-full",
    "1/4": "w-1/4",
    "1/3": "w-1/3",
    "1/2": "w-1/2",
    "2/3": "w-2/3",
    "3/4": "w-3/4",
    auto: "w-auto",
  };

  if (lines === 1) {
    return (
      <div
        className={`${sizeClasses[size]} ${widthClasses[width]} bg-gray-200 rounded animate-pulse ${className}`}
      />
    );
  }

  return (
    <div className={`space-y-2 ${className}`}>
      {Array.from({ length: lines }).map((_, index) => (
        <div
          key={index}
          className={`${sizeClasses[size]} ${widthClasses[width]} bg-gray-200 rounded animate-pulse`}
        />
      ))}
    </div>
  );
};

export default SkeletonText;
